import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DoneBanner from '../done_banner';
import { autocompletePlacesPath } from '../../../../../../utilities/api_relative_paths';
import AutocompleteBootstrap5 from '../../../../autocompletes/autocomplete_bootstrap_5';
import { updateEmploymentLocation } from '../../../services';

const EmploymentLocationBanner = ({ employments, removeBanner }) => {
  const [step, setStep] = useState('edit');
  const [employment, setEmployment] = useState({});
  const [places, setPlaces] = useState([]);

  /**
   * Finds the first element in the array of employments that doesn't have a location,
   * the employments are sorted by default from new to old in the array.
   *
   * @returns {undefined}
   */
  useEffect(() => {
    setEmployment(employments.find((ele) => ele.places.length === 0));
  }, []);

  useEffect(() => {
    if (step === 'done') {
      setTimeout(removeBanner, 7000);
    }
  }, [step]);

  /**
   * Formats and saves the selected location, as it's expected to be received in the BE
   * The location id could be "city-1234" or "country-1234", for that reason we need to
   * use the slice method.
   *
   * @param {object} selected - location selected
   * @returns {undefined}
   */
  const onSelect = (selected) => {
    if (selected) {
      const place = {
        id: selected.id.slice(-4),
        text: selected.text,
        name: selected.text,
        placeKey: selected.id,
      };
      setPlaces([place]);
    }
  };

  /**
   * Adds the location selected to the employment and then calls the
   * service method updateEmploymentLocation with the employment updated.
   *
   * @returns {undefined}
   */
  const handleUpdate = () => {
    const data = { ...employment, places };
    updateEmploymentLocation(data);
    setStep('done');
  };

  if (step === 'done') return <DoneBanner action='updating' />;
  return (
    <div className='data-input' data-testid='edit-employment-location'>
      <div className='form-group mb-3'>
        <label className='mb-35 text-center'>
          Including the location of your work experience allows you to be discovered by recruiters
          and professionals in the global development community.
        </label>
        <div className='form-group mb-3'>
          <span
            data-testid='employment-title'
            className='btn btn-outline-info mb-25'
          >
            {employment.employment_title || ''}
          </span>
          <AutocompleteBootstrap5
            inputProps={{ className: 'form-control' }}
            placeholder='Select location'
            id='placesAutocomplete'
            apiPath={autocompletePlacesPath}
            onSelect={onSelect} />

        </div>
      </div>
      <div className='text-center'>
        <button className='btn btn-outline-primary' type='button' onClick={handleUpdate}>
          Update
        </button>
      </div>
    </div>
  );
};

EmploymentLocationBanner.propTypes = {
  employments: PropTypes.array.isRequired,
  removeBanner: PropTypes.func.isRequired,
};

export default EmploymentLocationBanner;
